module.exports = __webpack_public_path__ + "img/jquery.4827ca7b.png";